document.querySelectorAll('.counter-input').forEach((elem) => {

    let input = elem.querySelector('input');
    let plus = elem.querySelector('.plus');
    let minus = elem.querySelector('.minus');
    
    plus.addEventListener('click', () => {
      input.value = Number(input.value) + 1;
      updateInput()
    });
  
    minus.addEventListener('click', () => {
      input.value = Number(input.value) - 1;
      updateInput()
    });
  
    function updateInput() {
      input.value = input.value ? input.value : 0;
  
      if(input.value < 1) {
        input.value = '1';
      }
  
      if(input.value < 10) {
        input.value = 0 + input.value;
      }
    }
  });
  
  
  
  
  
  /* Start Custom Select */
  var x, i, j, l, ll, selElmnt, a, b, c;
  /* Look for any elements with the class "custom-select": */
  x = document.getElementsByClassName("ui-dropdown");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      /* For each option in the original select element,
      create a new DIV that will act as an option item: */
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function(e) {
          /* When an item is clicked, update the original select box,
          and the selected item: */
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
      /* When the select box is clicked, close any other select boxes,
      and open/close the current select box: */
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }
  
  function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  
  /* If the user clicks anywhere outside the select box,
  then close all select boxes: */
  document.addEventListener("click", closeAllSelect);
  /* End Custom Select */
  
  
  
  Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        } 
    }
    return this;
  };
  
  
  
  
  /* Show / Hide options */
  let getDataOptions = document.querySelectorAll('[data-option]');
  
  getDataOptions.forEach((dataOption) => {
  
    dataOption.addEventListener('click', (e) => {
      e.preventDefault();
  
      getDataOptions.forEach((elem) => {
        elem.classList.remove('fill-perm');
      });
  
      dataOption.classList.add('fill-perm');
  
      document.querySelectorAll('[data-option-values]').forEach((elem) => {
  
        document.querySelector('#book-now-form-cal').classList.add('book-now-form-cal-disabled');
  
        document.querySelectorAll('.book-now-date-picker').forEach((bndp) => {
          bndp.classList.remove('book-now-date-picker-active');
        });
  
        if(Array.from(elem.dataset.optionValues).remove(',').includes(dataOption.dataset.option)) {
          elem.classList.add('current-option');
        } else {
          elem.classList.remove('current-option');
        }
        elem.classList.remove('disabled-option');
      });
  
    });
  });
  